var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C5.4087 18 3.88258 17.3679 2.75736 16.2426C1.63214 15.1174 1 13.5913 1 12C1 10.4087 1.63214 8.88258 2.75736 7.75736C3.88258 6.63214 5.4087 6 7 6H9V7.78806H7C5.88292 7.78806 4.8116 8.23182 4.02171 9.02171C3.23182 9.8116 2.78806 10.8829 2.78806 12C2.78806 13.1171 3.23182 14.1884 4.02171 14.9783C4.8116 15.7682 5.88292 16.2119 7 16.2119H9V18H7Z",
    fill: "#2B323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18C18.5913 18 20.1174 17.3679 21.2426 16.2426C22.3679 15.1174 23 13.5913 23 12C23 10.4087 22.3679 8.88258 21.2426 7.75736C20.1174 6.63214 18.5913 6 17 6H15V7.78806H17C18.1171 7.78806 19.1884 8.23182 19.9783 9.02171C20.7682 9.8116 21.2119 10.8829 21.2119 12C21.2119 13.1171 20.7682 14.1884 19.9783 14.9783C19.1884 15.7682 18.1171 16.2119 17 16.2119H15V18H17Z",
    fill: "#2B323B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 10,
    height: 2,
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.72b06dd359f841bf3bbba833a3fd42a5.svg";
export { ForwardRef as ReactComponent };